import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { MdgpDbApiProxyRef, MdgpDbApiClient } from './api';

export const MdgpDashboardPlugin = createPlugin({
  id: 'mdgp-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: MdgpDbApiProxyRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory(deps) {
        return new MdgpDbApiClient(deps);
      },
    }),
  ],
});

export const MdgpDashboardPage = MdgpDashboardPlugin.provide(
  createRoutableExtension({
    name: 'MdgpDashboardPage',
    component: () => import('./components').then(m => m.MdgpHomePageComponent),
    mountPoint: rootRouteRef,
  }),
);
